import React, { useState } from 'react';

import { InputLabel, Stack } from '@mui/material';
import { AlignBottom, AlignLeft, AlignRight, AlignTop } from 'iconsax-react';

import { RawSliderInput } from './RawSliderInput';

type TPaddingValue = {
  top: number;
  bottom: number;
  right: number;
  left: number;
};

type Props = {
  label: string;
  defaultValue: TPaddingValue | null;
  onChange: (value: TPaddingValue) => void;
};

export const PaddingInput: React.FC<Props> = ({
  label,
  defaultValue,
  onChange,
}) => {
  const [value, setValue] = useState(() => {
    if (defaultValue) {
      return defaultValue;
    }
    return {
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,
    };
  });

  function handleChange(internalName: keyof TPaddingValue, nValue: number) {
    const data = {
      ...value,
      [internalName]: nValue,
    };
    setValue(data);
    onChange(data);
  }

  return (
    <Stack spacing={2} alignItems="flex-start" pb={1}>
      <InputLabel shrink>{label}</InputLabel>

      <RawSliderInput
        iconLabel={<AlignTop variant="TwoTone" size="16" />}
        value={value.top}
        setValue={num => handleChange('top', num)}
        units="px"
        step={4}
        min={0}
        max={80}
        marks
      />

      <RawSliderInput
        iconLabel={<AlignBottom variant="TwoTone" size="16" />}
        value={value.bottom}
        setValue={num => handleChange('bottom', num)}
        units="px"
        step={4}
        min={0}
        max={80}
        marks
      />

      <RawSliderInput
        iconLabel={<AlignLeft variant="TwoTone" size="16" />}
        value={value.left}
        setValue={num => handleChange('left', num)}
        units="px"
        step={4}
        min={0}
        max={80}
        marks
      />

      <RawSliderInput
        iconLabel={<AlignRight variant="TwoTone" size="16" />}
        value={value.right}
        setValue={num => handleChange('right', num)}
        units="px"
        step={4}
        min={0}
        max={80}
        marks
      />
    </Stack>
  );
};
